module.exports = "/_next/static/images/545de63db4d0f15edabad59492f3b846-double-card@md-2x.png.webp";